import WebComponent from "fg-frontend/src/webComponents/WebComponent";
import $ from 'jquery';
import '../eshop-widgets/jquery.global-filter'

export default class GlobalFilter extends WebComponent {
  didMount() {
    $(this.element).globalFilter();
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GlobalFilter.js